import { strCode } from "../../localizations/strCode";

const deviceErrors = {
  DEVICE_NOT_FOUND: strCode.DEVICE_NOT_FOUND,
  DEVICE_ALREADY_CONNECTED_TO_KIT: strCode.DEVICE_ALREADY_CONNECTED_TO_KIT,
  DEVICE_KIT_ALREADY_FULL: strCode.DEVICE_KIT_ALREADY_FULL
};

export default deviceErrors;
